import CascateList from "../../../../../../common/components/cascate_list";
import DefaultInput from "../../../../../../common/components/default_input";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../../common/components/primary_button";

/**
 * Header
 */

type Props = {
  nome: string | null;
  onNomeChange: (nome: string | null) => void;
  onClearFilters: () => void;
};

export const Header = ({
  nome,
  onNomeChange,
  onClearFilters,
}: Props) => {
  return (
    <CascateList title="Filtros" defaultOpen={true}>
      <div className="w-full flex flex-col gap-4">
        <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div className="w-full col-span-1 md: col-span-2 lg:col-span-3">
            <DefaultInput
              name='nome'
              label='Nome de Epi'
              value={nome}
              onChangeValue={onNomeChange}
            />
          </div>
        </div>

        <div className="w-full flex justify-end">
          <div className="w-[180px]">
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
              buttonColor="yellow"
              onClick={onClearFilters}>
              Limpar filtros
            </PrimaryButton>
          </div>
        </div>
      </div>
    </CascateList>
  );
}